const url = {
  hash: () => window.location.hash.replace('#', ''),
}

export {
  url
}